import React, { useState, useEffect } from 'react';
import { Clock, AlertTriangle } from 'lucide-react';
import { resumeApi } from '../../../services/resumeApi';

const ProcessingStatusBadge = ({ jobId }) => {
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(false);
  // HIR-HR10: CVs are scored only by the CV Screener agent. When it is
  // switched off nothing scores, and saying "processing" would mislead.
  const [screenerDisabled, setScreenerDisabled] = useState(false);

  const fetchPendingCount = async () => {
    try {
      setLoading(true);
      const response = await resumeApi.getProcessingStatus(jobId);
      
      // Count pending resumes
      let count = 0;
      if (response.data.processingStats?.resumeStats) {
        const stats = response.data.processingStats.resumeStats;
        if (Array.isArray(stats)) {
          const pendingItem = stats.find(item => item._id === 'uploaded' || item._id === 'processing');
          count = pendingItem ? pendingItem.count : 0;
        } else {
          count = (stats.uploaded || 0) + (stats.processing || 0);
        }
      }
      
      setPendingCount(count);
      setScreenerDisabled(response.data?.screener?.status === 'disabled');
    } catch (error) {
      console.error('Error fetching pending count:', error);
      setPendingCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (jobId) {
      fetchPendingCount();
      
      // Refresh every 30 seconds
      const interval = setInterval(fetchPendingCount, 30000);
      return () => clearInterval(interval);
    }
  }, [jobId]);

  if (screenerDisabled) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-red-50 border border-red-200 rounded-lg text-red-700">
        <AlertTriangle className="w-4 h-4" />
        <span className="text-sm font-medium">
          {`CV Screener disabled — CVs are not being scored${pendingCount ? ` (${pendingCount} waiting)` : ''}`}
        </span>
      </div>
    );
  }

  if (pendingCount === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700">
      <Clock className="w-4 h-4" />
      <span className="text-sm font-medium">
        {loading ? 'Checking...' : `${pendingCount} resume${pendingCount !== 1 ? 's' : ''} processing`}
      </span>
    </div>
  );
};

export default ProcessingStatusBadge; 